import { compact } from 'lodash';

import { BUSINESSES } from '../constants';

export const opsRoles = [
  { name: 'Onsite', key: 'opsOnsiteId', business: BUSINESSES.MEDIA_ONSITE },
  {
    name: 'Onsite',
    key: 'opsOnsiteId',
    business: BUSINESSES.MEDIA_OFFSITE,
  },
  { name: 'CI', key: 'opsCiId', business: BUSINESSES.CONSUMER_INSIGHTS },
  { name: 'Creative', key: 'opsCreativeId', business: BUSINESSES.CREATIVE },
  { name: 'Other', key: 'opsOtherId', business: BUSINESSES.OTHER },
];

export const budgets = [
  {
    name: 'Media Onsite',
    business: BUSINESSES.MEDIA_ONSITE,
  },
  {
    name: 'Media Offsite',
    business: BUSINESSES.MEDIA_OFFSITE,
  },
  {
    name: 'Creative',
    business: BUSINESSES.CREATIVE,
  },
  {
    name: 'Consumer Insights',
    business: BUSINESSES.CONSUMER_INSIGHTS,
  },
  {
    name: 'Data',
    business: BUSINESSES.DATA,
  },
  {
    name: 'Other',
    business: BUSINESSES.OTHER,
  },
];

export const campaignLineStatuses = {
  DRAFT: 'Draft',
  READY: 'Ready',
  PUSHED: 'Pushed',
  LOCKED: 'Locked',
  GRANTED_VIA_CR: 'Granted via ChangeRequest',
};

export const STATUS_COLOR_MAP = {
  [campaignLineStatuses.GRANTED_VIA_CR]: 'success',
  [campaignLineStatuses.DRAFT]: 'info',
  [campaignLineStatuses.READY]: 'warning',
  [campaignLineStatuses.PUSHED]: 'success',
  [campaignLineStatuses.LOCKED]: 'success',
};

export const complianceStatuses = {
  NONE: '',
  COMPLIANT: 'Compliant',
  NON_COMPLIANT: 'Non-Compliant',
};

export const COMPLIANCE_COLOR_MAP = {
  [complianceStatuses.NONE]: 'info',
  [complianceStatuses.COMPLIANT]: 'success',
  [complianceStatuses.NON_COMPLIANT]: 'danger',
};

export const DISCRETIONARY_MEDIA = 'Discretionary Media';

export const timezoneOptions = [
  {
    label: 'Berlin, Rome, Oslo (Central European Time)',
    value: 'Europe/Berlin',
  },
  {
    label: 'Lisbon, London, Belfast (Western European Time)',
    value: 'Europe/Lisbon',
  },
  {
    label: 'Helsinki, Riga, Tallinn (Eastern European Time)',
    value: 'Europe/Helsinki',
  },
];

export const LANGUAGES = [
  'EN - English',
  'DE - German',
  'FR - French',
  'ES - Spanish',
  'PL - Polish',
  'PT - Portuguese',
  'IT - Italian',
  'FI - Finnish',
  'DA - Danish',
  'NO - Norwegian',
  'CS - Czech',
  'SK - Slovak',
  'SV - Swedish',
  'NL - Dutch',
  'SL - Slovene',
  'LT - Lithuanian',
  'LV - Latvian',
  'ET - Estonian',
  'HR - Croatian',
  'HU - Hungarian',
  'RO - Romanian',
];

export const languagesOptions = LANGUAGES.map(language => ({
  label: language,
  value: language.slice(0, 2),
}));

export const languagesRange = [1, 2, 3, 4];

export const lineLanguages = line =>
  line
    ? compact([line.language1, line.language2, line.language3, line.language4])
    : [];

export const supportedLanguages = [
  'language1',
  'language2',
  'language3',
  'language4',
];

export const targetings = {
  NO_EXTENSION: 'No Extension',
  DESIGNER_EXPERIENCE: 'Designer Experience',
  THEMED_HOME: 'Themed Home',
};

export const collectionIdPrefix = /ern:collection:cnc:/;
export const contentIdPrefix = /ern:campaign:zcc:/;

export const clmContentPreviewTypes = { image: 'Image', video: 'Video' };
export const targetGroupALL = 'ALL';

export const wrongSKUsErrorMessage =
  'Some SKUs are not valid for the combinations of merchants and suppliers you provided';
